var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13505_19239)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81934 4.05273C8.512 4.05273 8.26285 4.3039 8.26285 4.61373V15.8335C8.26285 16.1433 8.512 16.3945 8.81934 16.3945C9.12665 16.3945 9.3758 16.1433 9.3758 15.8335V4.61373C9.3758 4.3039 9.12665 4.05273 8.81934 4.05273ZM11.1566 6.74549C11.1566 6.43566 11.4057 6.18449 11.713 6.18449C12.0204 6.18449 12.2695 6.43566 12.2695 6.74549V13.7017C12.2695 14.0116 12.0204 14.2627 11.713 14.2627C11.4057 14.2627 11.1566 14.0116 11.1566 13.7017V6.74549ZM5.8143 8.20404C5.50696 8.20404 5.25781 8.45521 5.25781 8.76504V13.2529C5.25781 13.5628 5.50696 13.8139 5.8143 13.8139C6.12164 13.8139 6.37079 13.5628 6.37079 13.2529V8.76504C6.37079 8.45521 6.12164 8.20404 5.8143 8.20404ZM14.6068 8.20404C14.2995 8.20404 14.0503 8.45521 14.0503 8.76504V11.9066C14.0503 12.2164 14.2995 12.4676 14.6068 12.4676C14.9141 12.4676 15.1633 12.2164 15.1633 11.9066V8.76504C15.1633 8.45521 14.9141 8.20404 14.6068 8.20404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0078 9.99864C20.0078 11.9764 19.4213 13.9097 18.3225 15.5541C17.2237 17.1986 15.6619 18.4802 13.8346 19.2371C12.0074 19.9939 9.99672 20.192 8.05691 19.8061C6.1171 19.4203 4.33527 18.4679 2.93674 17.0694C1.53822 15.671 0.585812 13.8892 0.19996 11.9495C-0.185893 10.0097 0.0121409 7.99915 0.769017 6.17195C1.52589 4.34476 2.80762 2.78304 4.45211 1.68426C6.0966 0.585491 8.03 -0.000976586 10.0078 -0.000976562L10.0078 0.798993C8.18822 0.798993 6.4095 1.33854 4.89657 2.34941C3.38363 3.36028 2.20445 4.79707 1.50812 6.47809C0.811795 8.15911 0.629604 10.0088 0.984588 11.7934C1.33957 13.578 2.21579 15.2172 3.50243 16.5038C4.78907 17.7904 6.42836 18.6666 8.21298 19.0215C9.99761 19.3765 11.8474 19.1943 13.5285 18.498C15.2096 17.8017 16.6464 16.6226 17.6573 15.1097C18.6682 13.5968 19.2078 11.8182 19.2078 9.99864L20.0078 9.99864Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13505_19239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.9992,
    fill: "white",
    transform: "translate(0.0078125 -0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecur);
export default __webpack_public_path__ + "static/media/recur.9fead3525eeee680c7827b4c24204261.svg";
export { ForwardRef as ReactComponent };